import classes from "./Dropdown.module.scss";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

type Props = {
  dropdownArr: {
    title: string;
    link: string;
    reDirect: boolean;
  }[];
  containerClass?: string;
  dropdownItemClass?: string;
  parentPath: string;
  dropdownVisibility: boolean;
  seperatorClass?: string;
  setHeaderPopupVisibility?: (value: boolean) => void;
};

// const dropdownArr = [
//   {
//     title: "SE Solutions",
//     link: "/solutions",
//     reDirect: false,
//   },
//   {
//     title: "CLEM",
//     link: "https://clem.sustainabilityeconomics.com/",
//     reDirect: true,
//     disabled: false,
//     childPopup: false,
//     childArr: [
//       {
//         title: "CLEM Transition",
//         link: "https://clem.sustainabilityeconomics.com/",
//         reDirect: false,
//         disabled: true,
//       },
//       {
//         title: "CLEM Enablement",
//         link: "https://clem.sustainabilityeconomics.com/",
//         reDirect: false,
//         disabled: true,
//       },
//     ],
//   },
// ];

function Dropdown(props: Props) {
  const {
    dropdownArr,
    dropdownVisibility,
    parentPath,
    containerClass,
    dropdownItemClass,
    seperatorClass,
    setHeaderPopupVisibility,
  } = props;
  const navigate = useNavigate();

  const [subDropdownVisibility, setSubDropdownVisiblity] = useState<any>({});

  const mouseEventHandler = (receivedIndex: number) => () => {
    let tempVisibilityObj = { ...subDropdownVisibility } as any;

    tempVisibilityObj[receivedIndex] = !tempVisibilityObj[receivedIndex];

    setSubDropdownVisiblity(tempVisibilityObj);
  };

  return (
    <div
      className={`${classes["dropdown-container"]} ${
        containerClass ? containerClass : ""
      } ${dropdownVisibility ? classes["is-visible"] : ""}`}
    >
      {dropdownArr.map((item, index) => (
        <>
          <div
            key={index}
            className={`${classes["dropdown-item"]} ${
              dropdownItemClass ? dropdownItemClass : ""
            }`}
            role="button"
            onClick={() => {
              if (item.reDirect) {
                window.open(item.link, "_blank");
              } else {
                navigate(parentPath + item.link);
              }

              if (setHeaderPopupVisibility) setHeaderPopupVisibility(false);
            }}
          >
            {item.title}
            {/* {item.childPopup && (
              <div className={classes["right-arrow-container"]}>
                <FilledArrow
                  style={{
                    transition: "transform 0.4s ease",
                  }}
                  arrowType={"right"}
                />
              </div>
            )} */}
            {/* {subDropdownVisibility[index] && (
              <div className={classes["sub-dropdown-container"]}>
                {item.childArr?.map((subEle, subIndex) => {
                  return (
                    <>
                      <div
                        className={classes["sub-dropdown-item"]}
                        onClick={() => {
                          if (subEle.reDirect && !subEle.disabled) {
                            window.open(subEle.link, "_blank");
                          } else if (!subEle.disabled) {
                            navigate(parentPath + subEle.link);
                          }

                          if (setHeaderPopupVisibility)
                            setHeaderPopupVisibility(false);
                        }}
                      >
                        {subEle.title}
                      </div>
                      {subIndex !== item.childArr.length - 1 && (
                        <div className={classes["separator"]}></div>
                      )}
                    </>
                  );
                })}
              </div>
            )} */}
          </div>

          {/* {index !== dropdownArr.length - 1 && (
            <div
              className={`${classes.seperator} ${
                seperatorClass ? seperatorClass : ""
              }`}
            />
          )} */}
        </>
      ))}
    </div>
  );
}

export default Dropdown;
